module.exports = __webpack_public_path__ + "static/media/trial3_1.93e68f75.png";